import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({ name: 'luxon' })
export class LuxonPipe implements PipeTransform {

    transform(value: string | DateTime, format: string = 'MMM d, y h:mm a'): string {
        if ( value instanceof DateTime ) {
            return this.transformDateTime(value, format);
        } else {
            return this.transformString(value, format);
        }
    }

    transformDateTime(datetime: DateTime, format: string = 'MMM d, y h:mm a'): string {

        const localDatetime = datetime.toLocal();

        if (localDatetime.invalidExplanation) {
            return '';
        }

        return localDatetime.toFormat(format);
    }

    // If it's a string, we assume its a data string coming straight from .NET
    // so we need to convert to a luxon DateTime object before formating
    transformString(value: string, format: string = 'MMM d, y h:mm a'): string {

        const datetime = DateTime.fromISO(value, { zone: 'utc' });

        if (!datetime.isValid) {
            return value;
        }

        const localDatetime = datetime.toLocal();

        if (localDatetime.invalidExplanation) {
            return value;
        }

        return localDatetime.toFormat(format);
    }
}
